import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M17.256 16h-1.34l-1.13-1.58-1.12 1.58h-1.33l1.79-2.52-1.69-2.37h1.35l1.01 1.43 1.02-1.43h1.32l-1.67 2.36zM7.02 16v-.85l2.44-2.41c.72-.71 1.07-1.12 1.07-1.67 0-.6-.48-1.03-1.13-1.03-.79 0-1.28.51-1.29 1.37l-1.15-.06c0-1.44 1.09-2.45 2.45-2.45 1.33 0 2.32.89 2.32 2.14 0 .87-.57 1.62-1.44 2.44l-1.38 1.38h2.87V16z"
    }
  )
);
var SvgSpeed200XFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var Speed200XFilled_default = SvgSpeed200XFilled;

export { Speed200XFilled_default as default };
